import {useUserPreferencesStore} from '../store';
import {getUserId} from './getUserId';

export const setUserPreference = (key: string, value: any) => {
	if (getUserId() === 0) return;
	useUserPreferencesStore.getState().set(key, value);
}

// TODO: rename all instances of setPreference to setUserPreference
export const setPreference = setUserPreference;

export default setUserPreference;
